/* Les Gastronomes — Guernsey bottle deposit automation (Avenue 13.2.0) */
(function () {
  'use strict';

  var MILK_VARIANT_ID = 52572281143585;
  var DEPOSIT_VARIANT_ID = 53226525983009;
  var syncing = false;
  var queued = false;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function cartUrl(path) {
    return root() + path.replace(/^\//, '');
  }

  function getCart() {
    return fetch(cartUrl('cart.js'), {
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('Unable to read cart');
      return r.json();
    });
  }

  function addDeposit(quantity) {
    return fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: DEPOSIT_VARIANT_ID,
          quantity: quantity,
          properties: { '_lg_bottle_deposit': 'Guernsey Fresh Milk 1L' }
        }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Unable to add bottle deposit');
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(cartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error('Unable to update bottle deposit');
      return r.json();
    });
  }

  function refreshAvenueCart() {
    try {
      if (typeof CartDrop === 'function') CartDrop(true);
    } catch (e) {}

    if (window.theme && theme.cart && typeof CartReload === 'function') {
      fetch(theme.routes_cart_url)
        .then(function (r) { return r.text(); })
        .then(function (html) { CartReload(html); })
        .catch(function (err) { console.error('Bottle deposit cart refresh:', err); });
    }
  }

  async function syncDeposit(refresh) {
    if (syncing) {
      queued = true;
      return;
    }

    syncing = true;
    try {
      var cart = await getCart();
      var milkQty = 0;
      var depositLines = [];
      var depositQty = 0;

      cart.items.forEach(function (item) {
        if (Number(item.variant_id) === MILK_VARIANT_ID) milkQty += item.quantity;
        if (Number(item.variant_id) === DEPOSIT_VARIANT_ID) {
          depositLines.push(item);
          depositQty += item.quantity;
        }
      });

      var changed = false;

      if (milkQty === 0) {
        for (var i = 0; i < depositLines.length; i++) {
          await changeLine(depositLines[i].key, 0);
          changed = true;
        }
      } else if (depositLines.length === 0) {
        await addDeposit(milkQty);
        changed = true;
      } else {
        if (depositQty !== milkQty || depositLines.length > 1) {
          await changeLine(depositLines[0].key, milkQty);
          changed = true;
          for (var d = 1; d < depositLines.length; d++) {
            await changeLine(depositLines[d].key, 0);
          }
        }
      }

      if (refresh && changed) refreshAvenueCart();
    } catch (err) {
      console.error('Les Gastronomes bottle deposit sync:', err);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        setTimeout(function () { syncDeposit(true); }, 100);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncDeposit(true);
  });

  document.addEventListener('cartItems', function () {
    setTimeout(function () { syncDeposit(true); }, 100);
  });

  /* Avenue cart quantity changes complete asynchronously. Re-check after interaction. */
  document.addEventListener('click', function (event) {
    if (event.target.closest('#cart-table .qtybtn')) {
      setTimeout(function () { syncDeposit(true); }, 650);
    }
  }, true);

  document.addEventListener('keyup', function (event) {
    if (event.target && event.target.matches('#cart-table .item-qty')) {
      setTimeout(function () { syncDeposit(true); }, 950);
    }
  }, true);

  /* Final guard: verify the deposit before any standard checkout submission. */
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    var checkout = form && form.querySelector('[name="checkout"]');
    if (!checkout || form.dataset.lgDepositVerified === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    await syncDeposit(false);
    form.dataset.lgDepositVerified = 'true';
    if (checkout.click) checkout.click();
    else form.submit();
  }, true);

  window.LGSyncBottleDeposit = syncDeposit;
})();
